import { createTheme, Theme } from "@mui/material/styles";

/**
 * Shared typography for primary dashboard CTAs on the patient portal:
 * Start a call, Watch now, Play a game, Start session, etc.
 * Applied via portal theme `MuiButton` `size="large"` overrides.
 */
export const portalDashboardLargeButtonFont = {
  fontSize: "1.125rem",
  fontWeight: 500,
  lineHeight: 1.35,
} as const;

/**
 * Nested theme for `/portal/*`: larger buttons and icon targets for elderly users.
 * Merge with the root theme via ThemeProvider.
 */
export function createPortalTheme(baseTheme: Theme): Theme {
  return createTheme(baseTheme, {
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            "&.MuiButton-sizeLarge": {
              minHeight: 56,
              paddingLeft: baseTheme.spacing(3),
              paddingRight: baseTheme.spacing(3),
              ...portalDashboardLargeButtonFont,
            },
            "&.MuiButton-sizeMedium": {
              minHeight: 48,
              paddingLeft: baseTheme.spacing(2.5),
              paddingRight: baseTheme.spacing(2.5),
              fontSize: "1rem",
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            padding: 10,
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          h6: {
            fontSize: "1.375rem",
          },
          subtitle1: {
            fontSize: "1.0625rem",
          },
        },
      },
    },
  });
}
